<div class="space-y-5">
  <div class="space-y-6">
    <!-- SECTION TÉLÉPHONE -->
    <div
      class="p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs space-y-3.5"
    >
      <div class="flex items-center justify-between gap-3">
        <div class="flex items-center gap-2.5">
          <div
            class="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
            [class.bg-primary-2]="showPhone()"
            [class.text-primary-11]="showPhone()"
            [class.bg-neutral-2]="!showPhone()"
            [class.dark:bg-neutral-3]="!showPhone()"
            [class.text-neutral-10]="!showPhone()"
          >
            <mat-icon class="!w-4 !h-4 !text-base">
              {{ showPhone() ? 'call' : 'phone_disabled' }}
            </mat-icon>
          </div>
          <div class="flex flex-col">
            <span class="text-sm font-bold text-neutral-12">Numéro de téléphone portable professionnel</span>
            <span class="text-xs text-neutral-10">Sur votre profil professionnel pour vos clients</span>
          </div>
        </div>
        <mat-slide-toggle [checked]="showPhone()" (change)="toggleShowPhone($event.checked)" />
      </div>

      @if (showPhone()) {
        <div class="pt-3 border-t border-neutral-3 dark:border-neutral-4 flex flex-col gap-3">
          <div class="grid grid-cols-1 md:grid-cols-12 gap-3.5 items-stretch">
            <!-- Colonne gauche : Bouton explicatif du compte par défaut -->
            <button
              type="button"
              (click)="clearPhone()"
              class="md:col-span-5 text-left p-3.5 rounded-2xl border transition-all flex flex-col justify-between cursor-pointer group"
              [class.border-primary-6]="!hasCustomPhone()"
              [class.bg-primary-1]="!hasCustomPhone()"
              [class.shadow-xs]="!hasCustomPhone()"
              [class.border-neutral-3]="hasCustomPhone()"
              [class.dark:border-neutral-4]="hasCustomPhone()"
              [class.bg-white]="hasCustomPhone()"
              [class.dark:bg-neutral-2]="hasCustomPhone()"
              [class.hover:border-neutral-4]="hasCustomPhone()"
              [class.hover:bg-neutral-1/60]="hasCustomPhone()"
              matTooltip="Cliquer pour utiliser le numéro de votre compte personnel"
            >
              <div class="space-y-2.5 w-full">
                <div class="flex items-center justify-between gap-2">
                  <div
                    class="flex items-center gap-1.5 text-xs font-bold"
                    [class.text-primary-11]="!hasCustomPhone()"
                    [class.text-neutral-11]="hasCustomPhone()"
                  >
                    <mat-icon class="!w-4 !h-4 !text-base">account_circle</mat-icon>
                    <span>Numéro du compte</span>
                  </div>
                  @if (!hasCustomPhone()) {
                    <span
                      class="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-white dark:bg-neutral-3 text-primary-11 border border-primary-4 flex items-center gap-1"
                    >
                      <mat-icon class="!w-3 !h-3 !text-xs">check</mat-icon>
                      Par défaut
                    </span>
                  } @else {
                    <span
                      class="text-[10px] font-medium text-neutral-10 group-hover:text-primary-11 transition-colors"
                    >
                      Utiliser le compte
                    </span>
                  }
                </div>

                <div
                  class="p-2 rounded-xl border text-xs font-bold font-mono"
                  [class.bg-white]="!hasCustomPhone()"
                  [class.dark:bg-neutral-2]="!hasCustomPhone()"
                  [class.border-primary-3]="!hasCustomPhone()"
                  [class.text-neutral-12]="defaultPhone()"
                  [class.bg-neutral-1]="hasCustomPhone()"
                  [class.dark:bg-neutral-3]="hasCustomPhone()"
                  [class.border-neutral-3]="hasCustomPhone()"
                  [class.dark:border-neutral-4]="hasCustomPhone()"
                  [class.text-neutral-8]="!defaultPhone()"
                >
                  {{ defaultPhone() || 'Aucun numéro sur le compte' }}
                </div>

                <p
                  class="text-[11px] leading-relaxed m-0"
                  [class.text-primary-10]="!hasCustomPhone()"
                  [class.text-neutral-9]="hasCustomPhone()"
                >
                  @if (!hasCustomPhone()) {
                    Ce numéro de compte est actuellement affiché à vos clients.
                  } @else {
                    Cliquez ici pour effacer le numéro dédié et revenir au numéro de compte.
                  }
                </p>
              </div>
            </button>

            <!-- Colonne droite : Input d'override -->
            <div
              class="md:col-span-7 flex flex-col justify-between p-3.5 rounded-2xl border transition-all"
              [class.border-primary-6]="hasCustomPhone()"
              [class.bg-primary-1/20]="hasCustomPhone()"
              [class.shadow-xs]="hasCustomPhone()"
              [class.border-neutral-3]="!hasCustomPhone()"
              [class.bg-neutral-1/30]="!hasCustomPhone()"
            >
              <div class="space-y-2.5">
                <div class="flex items-center justify-between gap-2">
                  <div class="flex items-center gap-2">
                    <span class="text-xs font-bold text-neutral-12">Numéro dédié personnalisé</span>
                    @if (hasCustomPhone()) {
                      <span
                        class="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-primary-2 text-primary-11 border border-primary-4"
                      >
                        Actif
                      </span>
                    }
                  </div>
                  @if (hasCustomPhone()) {
                    <button
                      type="button"
                      mat-button
                      class="!text-xs !text-neutral-10 !h-6 !px-2 hover:!text-danger-11"
                      (click)="clearPhone()"
                    >
                      Effacer
                    </button>
                  }
                </div>

                <aura-phone-number-input
                  [control]="phoneControl"
                  [required]="false"
                  label="Téléphone professionnel"
                  (numberChanged)="onNumberChanged($event)"
                />

                <span class="text-[11px] text-neutral-9 leading-relaxed block">
                  Renseignez un numéro dédié pour remplacer le numéro par défaut de votre compte personnel.
                </span>
              </div>
            </div>
          </div>
        </div>
      } @else {
        <div
          class="p-3 rounded-xl bg-neutral-1 dark:bg-neutral-3/40 border border-neutral-2 dark:border-neutral-4 flex items-center gap-2.5 text-xs text-neutral-10"
        >
          <mat-icon class="!w-4 !h-4 !text-base text-neutral-9">visibility_off</mat-icon>
          <span>Aucun numéro de téléphone ne sera visible pour vos clients.</span>
        </div>
      }
    </div>

    <!-- SECTION EMAIL -->
    <div
      class="p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs space-y-3.5"
    >
      <div class="flex items-center justify-between gap-3">
        <div class="flex items-center gap-2.5">
          <div
            class="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
            [class.bg-primary-2]="showEmail()"
            [class.text-primary-11]="showEmail()"
            [class.bg-neutral-2]="!showEmail()"
            [class.dark:bg-neutral-3]="!showEmail()"
            [class.text-neutral-10]="!showEmail()"
          >
            <mat-icon class="!w-4 !h-4 !text-base">
              {{ showEmail() ? 'alternate_email' : 'mail_lock' }}
            </mat-icon>
          </div>
          <div class="flex flex-col">
            <span class="text-sm font-bold text-neutral-12">Adresse email professionnelle</span>
            <span class="text-xs text-neutral-10">Sur votre profil professionnel pour vos clients</span>
          </div>
        </div>
        <mat-slide-toggle [checked]="showEmail()" (change)="toggleShowEmail($event.checked)" />
      </div>

      @if (showEmail()) {
        <div class="pt-3 border-t border-neutral-3 dark:border-neutral-4 flex flex-col gap-3">
          <div class="grid grid-cols-1 md:grid-cols-12 gap-3.5 items-stretch">
            <!-- Colonne gauche : Bouton explicatif du compte par défaut -->
            <button
              type="button"
              (click)="clearEmail()"
              class="md:col-span-5 text-left p-3.5 rounded-2xl border transition-all flex flex-col justify-between cursor-pointer group"
              [class.border-primary-6]="!hasCustomEmail()"
              [class.bg-primary-1]="!hasCustomEmail()"
              [class.shadow-xs]="!hasCustomEmail()"
              [class.border-neutral-3]="hasCustomEmail()"
              [class.dark:border-neutral-4]="hasCustomEmail()"
              [class.bg-white]="hasCustomEmail()"
              [class.dark:bg-neutral-2]="hasCustomEmail()"
              [class.hover:border-neutral-4]="hasCustomEmail()"
              [class.hover:bg-neutral-1/60]="hasCustomEmail()"
              matTooltip="Cliquer pour utiliser l'adresse de votre compte personnel"
            >
              <div class="space-y-2.5 w-full">
                <div class="flex items-center justify-between gap-2">
                  <div
                    class="flex items-center gap-1.5 text-xs font-bold"
                    [class.text-primary-11]="!hasCustomEmail()"
                    [class.text-neutral-11]="hasCustomEmail()"
                  >
                    <mat-icon class="!w-4 !h-4 !text-base">account_circle</mat-icon>
                    <span>Email du compte</span>
                  </div>
                  @if (!hasCustomEmail()) {
                    <span
                      class="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-white dark:bg-neutral-3 text-primary-11 border border-primary-4 flex items-center gap-1"
                    >
                      <mat-icon class="!w-3 !h-3 !text-xs">check</mat-icon>
                      Par défaut
                    </span>
                  } @else {
                    <span
                      class="text-[10px] font-medium text-neutral-10 group-hover:text-primary-11 transition-colors"
                    >
                      Utiliser le compte
                    </span>
                  }
                </div>

                <div
                  class="p-2 rounded-xl border text-xs font-bold truncate block"
                  [class.bg-white]="!hasCustomEmail()"
                  [class.dark:bg-neutral-2]="!hasCustomEmail()"
                  [class.border-primary-3]="!hasCustomEmail()"
                  [class.text-neutral-12]="defaultEmail()"
                  [class.bg-neutral-1]="hasCustomEmail()"
                  [class.dark:bg-neutral-3]="hasCustomEmail()"
                  [class.border-neutral-3]="hasCustomEmail()"
                  [class.dark:border-neutral-4]="hasCustomEmail()"
                  [class.text-neutral-8]="!defaultEmail()"
                >
                  {{ defaultEmail() || 'Aucun email sur le compte' }}
                </div>

                <p
                  class="text-[11px] leading-relaxed m-0"
                  [class.text-primary-10]="!hasCustomEmail()"
                  [class.text-neutral-9]="hasCustomEmail()"
                >
                  @if (!hasCustomEmail()) {
                    Cette adresse de compte est actuellement affichée à vos clients.
                  } @else {
                    Cliquez ici pour effacer l'email dédié et revenir à l'adresse de compte.
                  }
                </p>
              </div>
            </button>

            <!-- Colonne droite : Input d'override -->
            <div
              class="md:col-span-7 flex flex-col justify-between p-3.5 rounded-2xl border transition-all"
              [class.border-primary-6]="hasCustomEmail()"
              [class.bg-primary-1/20]="hasCustomEmail()"
              [class.shadow-xs]="hasCustomEmail()"
              [class.border-neutral-3]="!hasCustomEmail()"
              [class.bg-neutral-1/30]="!hasCustomEmail()"
            >
              <div class="space-y-2.5">
                <div class="flex items-center justify-between gap-2">
                  <div class="flex items-center gap-2">
                    <span class="text-xs font-bold text-neutral-12">Email dédié personnalisé</span>
                    @if (hasCustomEmail()) {
                      <span
                        class="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-primary-2 text-primary-11 border border-primary-4"
                      >
                        Actif
                      </span>
                    }
                  </div>
                  @if (hasCustomEmail()) {
                    <button
                      type="button"
                      mat-button
                      class="!text-xs !text-neutral-10 !h-6 !px-2 hover:!text-danger-11"
                      (click)="clearEmail()"
                    >
                      Effacer
                    </button>
                  }
                </div>

                <mat-form-field appearance="outline" class="w-full">
                  <input
                    matInput
                    type="email"
                    [formControl]="emailControl"
                    placeholder="ex: prenom.nom@reseau-immo.fr"
                    aria-label="Adresse e-mail professionnelle"
                  />
                  <mat-icon matPrefix class="mr-2 text-neutral-9">alternate_email</mat-icon>
                </mat-form-field>

                <span class="text-[11px] text-neutral-9 leading-relaxed block">
                  Renseignez une adresse dédiée pour remplacer l'adresse par défaut de votre compte personnel.
                </span>
              </div>
            </div>
          </div>
        </div>
      } @else {
        <div
          class="p-3 rounded-xl bg-neutral-1 border border-neutral-2 flex items-center gap-2.5 text-xs text-neutral-10"
        >
          <mat-icon class="!w-4 !h-4 !text-base text-neutral-9">visibility_off</mat-icon>
          <span>Aucune adresse email ne sera visible pour vos clients.</span>
        </div>
      }
    </div>
  </div>
</div>
